export const HeadingType = 'HEADING';
